import { render, staticRenderFns } from "./InvitationCard.vue?vue&type=template&id=8947408c&"
import script from "./InvitationCard.vue?vue&type=script&lang=js&"
export * from "./InvitationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports